<app-header></app-header>
<router-outlet class='app-main' (activate)="onRouterOutletActivate($event)"></router-outlet>
<router-outlet name="print"></router-outlet>
